/** RL-1658: the one-tap reasons; "Other" needs a short note. */
export const CANCEL_REASONS = ['left', 'mistake', 'other'] as const;
export type CancelReason = (typeof CANCEL_REASONS)[number];

/** The reason text the API keeps on the ticket (never sent to the patient). */
export function cancelReasonText(
  reason: CancelReason,
  note: string,
  t: (key: string) => string,
): string {
  if (reason === 'other') return note.trim();
  return t(`queue.cancel.reason.${reason}`);
}
